module.exports = {
    defaultLanguage: 'es',
    profileColor: {saturation: 78, brightness: 100},
    scssVariables: './src/styles/tom2023',
    defaultPassword: 'default'
}